<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
          <!-- <v-btn :disabled="btnSave" color="green" outline dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" outline dark @click="back()">Cancel</v-btn> -->
    </v-toolbar>
    
    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                         <div class="res" style="margin-left:50px;margin-right:50px;">
                           <img :src=this.form.imageSrc width="100%" height="300px">
                         </div>

                         <div class="man" style="margin-left:20px;margin-right:20px;">
                           <img :src=this.form.imageSrc width="100%" height="300px">
                         </div>
                         
                       </v-flex>
          <v-flex xs12>
            <v-text-field :readonly="edit === false" v-model="form.title" label="Title *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea :readonly="edit === false" :auto-grow="true" outline v-model="form.description" label="Description"></v-textarea>
          </v-flex>
         
        </v-layout>
        <v-card-actions>
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          <v-btn :disabled="edit === false" :loadings="btnSave" color="green" dark @click="onSubmit()">Save </v-btn>
          <v-btn v-if="form.approved === false && roleType === 'Administrator'" :loadings="approve" color="primary" dark @click="approves(form)">Approve </v-btn>
          <v-btn color="red" dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "View Blog",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      edit: false,
      approve: false,

      roleType: sessionStorage.roles,
      


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "My Blog",
          disabled: false,
          to: "/myBlog"
        },
        {
          text: "View Blog",
          disabled: true,
          to: "/editMyBlog"
        }
      ],

      form: {
        title: null,
        description: null
      }
    };
  },

  mounted() {
      this.axios
      .get(config.API + `Blogs/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
      });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },


    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let blogCode = "MB" + Math.floor(100000000000 + Math.random() * 900000000000);
        this.axios
          .post(
            config.API + `Blogs`,
            {
              blogCode: blogCode,
              title: this.form.title,
              description: this.form.description
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Blog successfully created");
            this.$router.push("/imageMyBlog/" + blogCode);
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    approves(form) {
      // alert(item.id);
      if (confirm("You want to Approve this Blog !!")) {
          this.approve = true;
        this.axios
          .delete(config.API + `Blogs1/${form.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Blog Approved successfully");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.approve = false;
          });
      }
    },
  },
};
</script>

<style>
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>
